import getSpecificAuction from './getSpecificAuction'

async function getPeriodBrandingPPCAuctions({ search = '', page = 1 } = {}, campaignId) {
    try {
        return await getSpecificAuction({ search, page }, campaignId, 'branding')
    } catch (error) {
        console.log(error)
    }
}

export default getPeriodBrandingPPCAuctions
